<template>
  <div>
    <div class="p-6 pb-0">
      <BreadCrumbs :navigation="navigation" />
    </div>
    <div class="p-6 pb-0">
      <button @click="newContract" class="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 mb-4 rounded-md shadow-md">Nuovo Contratto</button>
      <table class="min-w-full bg-white rounded-md shadow-lg">
        <thead>
          <tr>
            <th class="py-2 px-4 border-b text-left">Id</th>
            <th class="py-2 px-4 border-b text-left">Data</th>
            <th class="py-2 px-4 border-b text-left">Cliente</th>
            <th class="py-2 px-4 border-b text-center">Azioni</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="contract in contracts.data" :key="contract.ContractId">
            <td class="py-2 px-4 border-b text-left">{{ contract.DocNo }}</td>
            <td class="py-2 px-4 border-b text-left">{{ formatDate(contract.StipulationDate) }}</td>
            <td class="py-2 px-4 border-b text-left">{{ contract.CompanyName }}</td>
            <td class="py-2 px-4 border-b text-center">
              <button @click="editContract(contract)" class="bg-yellow-500 hover:bg-yellow-600 text-white px-2 py-1 rounded-md mr-2">Modifica</button>
            </td>
          </tr>
          <tr>
            <td class="text-left" colspan="4"><Pagination :links="contracts.links" :only="['contracts']" /></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { Link, router, useForm } from '@inertiajs/vue3';
import BreadCrumbs from '@/Components/BreadCrumbs.vue';
import Pagination from '@/Components/Pagination.vue';

export default {
  props: ['contracts', 'lastContractCode', 'errors', 'agents', 'areaManagers'],
  components: {
    Link,
    BreadCrumbs,
    Pagination
  },
  data() {
    return {
      navigation: [
        { name: 'Dashboard', href: route('dashboard') },
        { name: 'Contratti', href: route('modules.home', 'contratti') },
        { name: 'Lista contratti', href: route('modules.contratti.lista') }
      ]
    };
  },
  methods: {
    newContract() {
      router.visit(route('modules.contratti.nuovo'));
    },
    editContract(contract) {
      router.visit(route('modules.contratti.esistente', contract.ContractId));
    },
  }
};
</script>